<template>
  <div id="whats-new-container">
    <div id="whats-new" v-if="text.length > 0" v-html="text"></div>
  </div>
</template>

<script>
import language from "../mixins/language.js";
export default {
  name: "WhatsNew",
  title: "What's New? | Explore with MWNF",
  mixins: [language],
  data() {
    return {
      text: "",
    };
  },
  methods: {
    getText: function () {
      axios({
        method: "GET",
        url: `${process.env.VUE_APP_API_ENDPOINT}/texts/what-is-new`,
      }).then(
        (result) => {
          let results = result.data;
          this.text = this.returnValueInLanguage("en", results).description;
        },
        (error) => {
          console.error(error);
        }
      );
    },
  },
  mounted() {
    this.getText();
  },
};
</script>

<style scoped lang="scss">
#whats-new-container {
  @include flex-center;
  background-color: white;
  width: 100%;
}
#whats-new {
  width: 50%;
  padding: 50px;
}
#whats-new :deep(a) {
  @include link-styles;
}
#whats-new :deep(a:hover) {
  @include link-hover-styles;
}

@media only screen and (max-width: 1349px) {
  #whats-new {
    width: 60%;
  }
}

@media only screen and (max-width: 1199px) {
  #whats-new {
    width: 70%;
  }
}

@media only screen and (max-width: 949px) {
  #whats-new {
    width: 80%;
  }
}

@media only screen and (max-width: 749px) {
  #whats-new {
    width: 90%;
    padding: 30px;
  }
}

@media only screen and (max-width: 599px) {
  #whats-new {
    width: 100%;
  }
}
</style>
